export const adminBatchSelectionCommon = {
  partialSelected: "先頭 {selected} 件を選択しました（現在の絞り込み対象は全 {total} 件で、超過分は未選択です）",
  allSelected: "{count} 件を選択しました",
};

export const adminBatchCommon = {
  publishDrafts: "一括公開（下書きのみ）",
  archive: "一括アーカイブ",
  deleteDrafts: "一括削除（下書きのみ）",
  confirmDeleteDraftsDescription: "削除後は元に戻せません。",
  archiveAction: "アーカイブ",
};

export function buildAdminConfirmBatchCommon(entity: string) {
  return {
    publishDraftsTitle: `選択した {count} 件の下書き${entity}を公開しますか？`,
    archiveTitle: `選択した {count} 件の${entity}をアーカイブしますか？`,
    deleteDraftsTitle: `選択した {count} 件の下書き${entity}を削除しますか？`,
    deleteDraftsDescription: "この操作は取り消せません。",
  };
}

export const adminArchivedToggleCommon = {
  showArchived: "アーカイブを表示",
  hideArchived: "アーカイブを隠す",
  summaryArchivedVisible: "アーカイブ表示：{value}",
};

export function buildAdminSummaryTotal(entity: string) {
  return `${entity}総数：{count}`;
}

export function buildAdminBatchSelectionMessages(entity: string) {
  return {
    selectDraftsToPublish: `公開できるのは下書き${entity}のみです。選択をやり直してください。`,
    selectArchivableToArchive: `アーカイブ可能な${entity}が選択されていません`,
    selectDraftsToDelete: `削除できるのは下書き${entity}のみです。選択をやり直してください。`,
  };
}

export function buildAdminBatchResultMessages(entity: string, publishArchiveUnit: string, deleteUnit: string) {
  return {
    batchPublished: `{count} ${publishArchiveUnit}の${entity}を公開しました`,
    batchArchived: `{count} ${publishArchiveUnit}の${entity}をアーカイブしました`,
    batchDeleted: `{count} ${deleteUnit}の下書き${entity}を削除しました`,
  };
}
